import { render, staticRenderFns } from "./PurchaseManager.vue?vue&type=template&id=20fde706&"
import script from "./PurchaseManager.vue?vue&type=script&lang=ts&"
export * from "./PurchaseManager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports